// Swipeable product gallery: keeps the dot buttons in sync with the visible slide and handles the --go command.
class SProductGallery extends HTMLElement {
  #ac = null;
  #raf = null;

  connectedCallback() {
    this.track = this.querySelector('[data-gallery-track]');
    if (!this.track) return;
    this.#ac = new AbortController();
    const signal = this.#ac.signal;

    this.addEventListener('command', (event) => {
      if (event.command !== '--go') return;
      const index = Number(event.source?.dataset.index || 0);
      this.#goTo(index);
    }, { signal });

    this.track.addEventListener('scroll', () => {
      if (this.#raf) return;
      this.#raf = requestAnimationFrame(() => {
        this.#raf = null;
        this.#sync();
      });
    }, { signal, passive: true });

    this.track.addEventListener('keydown', (event) => {
      if (event.target !== this.track) return;
      const rtl = getComputedStyle(this).direction === 'rtl';
      const next = rtl ? 'ArrowLeft' : 'ArrowRight';
      const prev = rtl ? 'ArrowRight' : 'ArrowLeft';
      if (event.key === next) { event.preventDefault(); this.#goTo(this.#current() + 1); }
      if (event.key === prev) { event.preventDefault(); this.#goTo(this.#current() - 1); }
    }, { signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
    if (this.#raf) cancelAnimationFrame(this.#raf);
  }

  get #slides() {
    return [...this.track.children];
  }

  #current() {
    const width = this.track.clientWidth || 1;
    return Math.round(Math.abs(this.track.scrollLeft) / width);
  }

  #goTo(index) {
    const slides = this.#slides;
    const clamped = Math.max(0, Math.min(slides.length - 1, index));
    const slide = slides[clamped];
    if (!slide) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    slide.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
  }

  #sync() {
    const index = this.#current();
    this.querySelectorAll('[data-gallery-dots] [data-index]').forEach((dot) => {
      if (Number(dot.dataset.index) === index) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }
}

if (!customElements.get('s-product-gallery')) customElements.define('s-product-gallery', SProductGallery);
